// O react-admin 5 manda null no lugar de campo limpo (defaultParse do useInput) e o
// Joi do backend recusa null em campo opcional. Tira null e '' do payload, que é o
// que o backend entende como "não informado". 0 e false ficam.
const cleanEmpty = <T extends Record<string, any>>(data: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(data).filter(([, value]) => value !== null && value !== '')
  ) as Partial<T>

export default cleanEmpty
